<div class="bg-gray-50 py-10 px-4">
  <div class="max-w-5xl mx-auto">
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-5xl font-black text-[#001d4a] mb-4">
        মেন্টরই<span class="text-orange-500">আরপি</span> সফটওয়্যারের টেকনিক্যাল ডেমো
      </h2>
      <p class="text-gray-500 font-medium">
        সফটওয়্যারের ফিচারগুলো বিস্তারিত দেখতে প্লে বাটনে ক্লিক করুন
      </p>
    </div>

    <div (click)="openVideo()"
      class="relative group cursor-pointer overflow-hidden rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,29,74,0.15)] bg-[#001d4a] aspect-video mb-10 border-[10px] border-white transition-all duration-500 hover:shadow-orange-500/20">
      @if (videoUrl) {
      <iframe [src]="videoUrl" class="w-full h-full" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
      </iframe>
      }
      @else {
      <img fill ngSrc="thumbnail.jpg.jpeg" alt="Software Demo"
        class="w-full h-full object-cover opacity-80 transition-transform duration-1000 group-hover:scale-110" />

      <div class="absolute inset-0 flex items-center justify-center">
        <div class="absolute w-24 h-24 bg-orange-500/40 rounded-full animate-ping"></div>

        <div
          class="relative w-24 h-24 bg-gradient-to-tr from-orange-600 to-orange-400 text-white rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(249,115,22,0.5)] transition-all duration-700 group-hover:scale-110 group-hover:rotate-[360deg] overflow-hidden">
          <div
            class="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000">
          </div>

          <i class="fa-solid fa-play text-4xl ml-1.5 drop-shadow-md"></i>
        </div>
      </div>
      }
    </div>
  </div>

  @if (isVideoVisible()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-[#001d4a]/95 backdrop-blur-md p-4">
    <button (click)="closeVideo()"
      class="absolute top-8 right-8 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-orange-500 hover:rotate-90 transition-all duration-300 text-3xl">
      &times;
    </button>

    <div class="w-full max-w-5xl aspect-video shadow-2xl rounded-3xl overflow-hidden border-2 border-white/20">
      @if (videoUrl) {
      <iframe [src]="videoUrl" class="w-full h-full" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
      </iframe>
      }
    </div>
  </div>
  }
</div>